import { createContext, ReactNode } from 'react';

interface MenuContextProps {
  onClick: () => void;
}

const MenuContext = createContext<Nullable<MenuContextProps>>(null);

interface MenuProviderProps {
  onClick: () => void;
  children: ReactNode;
}

/**
 * MenuProvider позволяет передать один обработчик события для всех дочерних MenuItem
 * (обычно это обработчик закрытия всплывающего окна)
 *
 * @example
 * <MenuProvider onClick={() => setIsOpen(false)}>
 *   <FancyPopup
 *     isOpen={isOpened}
 *     onChangeState={setIsOpen}
 *     body={(
 *       <MenuList>
 *         <MenuItem onClick={forward}>Forward</MenuItem>
 *         <MenuItem onClick={saveAsFolder}>Save as Folder</MenuItem>
 *         <MenuItem onClick={unpinAll}>Unpin All</MenuItem>
 *       </MenuList>
 *     )}
 *   />
 * </MenuProvider>
 */
export function MenuProvider(props: MenuProviderProps) {
  const { onClick, children } = props;

  return <MenuContext.Provider value={{ onClick }}>{children}</MenuContext.Provider>;
}

export default MenuContext;
